export default function upload(app)
{

    /**
     * Return the formatted file size
     *
     * @param file
     */

    const getFileSize = function(file)
    {
        return (file.size / Math.pow(1024,2)).toFixed(2) + ' MB'
    }

    /**
     * Upload the file block
     *
     * @param file
     * @param $context
     */

    const updateFileBlock = function(file, $context)
    {

        // Get the files list
        const $filesList = $context.find('.files-list')

        // If no file
        if(!file) {

            // Find the attachment
            const $attachment = $filesList.find('.attachment:last-child')

            // Hide the attachment
            $attachment.addClass('blank');

            // Hide the file list
            return $filesList.removeClass('show')

        }

        // Get the file block
        const $fileBlock = $filesList.find('.file, .attachment.blank, .attachment:last-child')

        // Show the element
        $fileBlock.removeClass('blank')

        // Update the file name
        $fileBlock.find('.name').text(file.name)

        // Update the file size
        $fileBlock.find('.size').text(getFileSize(file))

        // Show the files list
        $filesList.addClass('show')

    }

    /**
     * Callback for the change event for upload
     *
     * @return void
     */

    const onChange = function()
    {
        updateFileBlock(this.files[0], $(this).parents('form'))
    }

    /**
     * Remove the file
     *
     * @param event
     */

    const removeFile = function(event)
    {

        // Prevent the default action
        event.preventDefault()

        // Get the form
        const $form = $(this).parents('form')

        // Get the file upload
        const $fileUpload = $form.find('.file-upload')

        // Reset the file input
        $fileUpload.val('')

        // Hide the file block
        updateFileBlock(null, $form)

    }

    $(function(){

        // Get the body
        const $body = $('body')

        // Handle file input change
        $body.on('change', '.file-upload', onChange)

        // Remove selected file
        $body.on('click', '.files-list .remove-file', removeFile)

    })

}
